import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import AppLoaderFUllPage from "./loader/AppLoaderFullPage";
import AuthLayout from "./layout/AuthLayout";
import { ErrorBoundary } from "@/pages/ErrorBoumdary";
import AuthCheckLoader from "./loader/AuthCheckLoader";
import { useAuth } from "@/auth/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = React.memo(
  ({ children, redirectTo = "/" }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
      return <AuthCheckLoader />;
    }

    if (!isAuthenticated) {
      return <Navigate to={redirectTo} replace />;
    }
    return (
      <Suspense fallback={<AppLoaderFUllPage />}>
        <ErrorBoundary>
          <AuthLayout>{children}</AuthLayout>
        </ErrorBoundary>
      </Suspense>
    );
  }
);

export default ProtectedRoute;
